import React from 'react';
import {
	Box,
	ListItemIcon,
	ListItemText,
	MenuItem,
	MenuList,
	Popover,
} from '@mui/material';
import { DotsOption } from './icons';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import './TreeNodeMenu.css';

interface TreeNodeMenuProps {
	id?: string;
	onAction?: (action: string) => void;
}

export function TreeNodeMenu(
	{ id, onAction }: TreeNodeMenuProps = { id: 'simple-popover' }
) {
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleDelete = () => {
		if (onAction) onAction('delete');
		handleClose();
	};

	const open = Boolean(anchorEl);
	const popoverId = open ? id : undefined;

	return (
		<div className="tree-node-menu">
			<Box className="tree-icon">
				<DotsOption onClick={handleClick} />
			</Box>
			<Popover
				id={popoverId}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				sx={{
					'& .MuiPaper-root': {
						overflow: 'visible',
						marginLeft: '8px',
						marginTop: '8px',
						'&::before': {
							content: '""',
							position: 'absolute',
							width: '12px',
							height: '12px',
							backgroundColor: '#2D3748',
							borderTop: '1px solid #48BB78',
							borderLeft: '1px solid #48BB78',
							transform: 'rotate(45deg)',
							top: '-6px',
							right: '4px',
							marginLeft: '-6px',
						},
					},
				}}
			>
				<Box className="tree-node-menu__content">
					<MenuList sx={{ padding: 0 }}>
						<MenuItem>
							<ListItemIcon>
								<DeleteOutlineIcon fontSize="small" sx={{
									color: '#cbd5e0'
								}} />
							</ListItemIcon>
							<ListItemText
								sx={{
									'& .MuiTypography-root': {
										fontSize: '12px',
									},
								}}
								onClick={handleDelete}
							>
								Delete
							</ListItemText>
						</MenuItem>
					</MenuList>
				</Box>
			</Popover>
		</div>
	);
}
